<template>
    <div style="overflow: auto;" :style="{height: height}">

        <div v-if="contato">

            <form class="form-horizontal" >

                <div class="form-group">
                    <label for="numero" class="col-sm-2 control-label label-lg">TELEFONE:</label>
                    <div class="col-sm-2" :class="{'padding-bottom-md': isMobile}">
                        <input type="text" v-model="contato.numero" v-mask="'(##)#####-####'"
                               :class="{'input-lg': isMobile}"
                               maxlength="14" class="form-control" id="numero">
                    </div>
                    <label for="nome" class="col-sm-1 control-label label-lg">COD PAÍS:</label>
                    <div class="col-sm-2" :class="{'padding-bottom-md': isMobile}">
                        <select  v-model="contato.cod_pais" class="form-control">
                            <option value="+1">+1 - USA</option>
                            <option value="+54">+54 - ARGENTINA</option>
                            <option value="+55">+55 - BRASIL</option>
                            <option value="+56">+56 - CHILE</option>
                            <option value="+57">+57 - COLOMBIA</option>
                            <option value="+81">+81 - JAPÃO</option>
                            <option value="+595">+595 - PARAGUAI</option>
                            <option value="+598">+598 - URUGUAI</option>
                        </select>
                    </div>
                    <label for="nome" class="col-sm-1 control-label label-lg">NOME:</label>
                    <div class="col-sm-4" :class="{'padding-bottom-md': isMobile}">
                        <input type="text" v-model="contato.nome" :class="{'input-lg': isMobile}"
                               class="form-control" id="nome">
                    </div>
                </div>

                <div class="form-group">
                    <label for="parentesco" class="col-sm-2 control-label label-lg">CARGO / PARENTESCO:</label>
                    <div class="col-sm-3" :class="{'padding-bottom-md': isMobile}">
                        <input type="text" v-model="contato.parentesco" :class="{'input-lg': isMobile}"
                               class="form-control" id="parentesco">
                    </div>
                    <label for="email" class="col-sm-1 control-label label-lg">EMAIL:</label>
                    <div class="col-sm-3" >
                        <input type="text" v-model="contato.email" :class="{'input-lg': isMobile}"
                               class="form-control" id="email">
                    </div>
                    <label for="email" class="col-sm-1 control-label label-lg">TELEGRAM ID:</label>
                    <div class="col-sm-2" >
                        <input type="text" v-model="contato.telegram_id" :class="{'input-lg': isMobile}"
                               class="form-control" id="telegram_id">
                    </div>
                </div>

                <div class="form-group">
                    <label for="whatsapp" class="col-sm-2 col-xs-12 control-label label-lg">WHATSAPP:</label>
                    <div class="col-sm-1 col-xs-12 " :class="{'padding-bottom-md': isMobile}">
                        <combo-true-false :disabled="! edit" :class="{'input-lg': isMobile}" v-model="contato.whatsapp"/>
                    </div>

                    <label for="sms" class="col-sm-1 col-xs-12 control-label label-lg">SMS:</label>
                    <div class="col-sm-1 col-xs-12 " :class="{'padding-bottom-md': isMobile}">
                        <combo-true-false :disabled="! edit" :class="{'input-lg': isMobile}" v-model="contato.sms"/>
                    </div>

                    <label for="sms" class="col-sm-1 col-xs-12 control-label label-lg">TELEGRAM:</label>
                    <div class="col-sm-1 col-xs-12 " :class="{'padding-bottom-md': isMobile}">
                        <combo-true-false :disabled="! edit" :class="{'input-lg': isMobile}" v-model="contato.telegram"/>
                    </div>

                    <label class="col-sm-1 col-xs-12 control-label label-lg">COBRANÇA:</label>
                    <div class="col-sm-1 col-xs-12 " :class="{'padding-bottom-md': isMobile}">
                        <combo-true-false :disabled="! edit" :class="{'input-lg': isMobile}" v-model="contato.cobranca"/>
                    </div>

                    <label class="col-sm-1 col-xs-12 control-label label-lg">EVENTOS:</label>
                    <div class="col-sm-1 col-xs-12 " :class="{'padding-bottom-md': isMobile}">
                        <combo-true-false :disabled="! edit" :class="{'input-lg': isMobile}" v-model="contato.eventos"></combo-true-false>
                    </div>
                </div>

                <div class="form-group" >
                    <label for="whatsapp" class="col-sm-2 col-xs-12 control-label label-lg"></label>
                    <div class="col-sm-3 col-xs-6">
                        <button :class="{'btn-xs': ! isMobile, 'btn-sm': isMobile, }"
                                class="btn btn-block btn-primary" type="button" @click="save();">
                            SALVAR
                            <li class="fa fa-plus"></li></button>

                    </div>
                    <div class="col-sm-3 col-xs-6">

                        <button :class="{'btn-xs': ! isMobile, 'btn-sm': isMobile, }"
                                class="btn btn-block btn-default" type="button" @click="contato = null">
                            CANCELAR
                            <li class="fa fa-trash"></li></button>
                    </div>
                </div>
            </form>

        </div>
        <div v-else>
            <div class="row">
                <div class="col-lg-2 col-xs-6">
                    <button v-if="edit" :class="{'btn-xs': ! isMobile, 'btn-sm': isMobile, }"
                            @click="novo()" class="btn btn-block btn-info">NOVO CONTATO</button>
                </div>
                <div class="col-lg-2 col-xs-6">
                    <button v-if="edit && uuid" :class="{'btn-xs': ! isMobile, 'btn-sm': isMobile, }"
                            @click="saveTelefone()" class="btn btn-block  btn-success">SALVAR TELEFONES</button>
                </div>
            </div>

            <br  v-if="edit"/>

            <table class="table table-hover table-striped">
                <thead style="background-color: #1c699d; color: white;">
                <th style="padding: 10px;width: 100px">TELEFONE</th>
                <th style="padding: 10px;">NOME</th>
                <th class="hidden-xs" style="padding: 10px;">EMAIL</th>
                <th class="hidden-xs" style="padding: 10px;">PARENTESCO / CARGO</th>
                <th class="hidden-xs" style="padding: 10px;width: 80px;text-align: center">WHATSAPP</th>
                <th class="hidden-xs" style="padding: 10px;width: 60px;text-align: center">SMS</th>
                <th class="hidden-xs" style="padding: 10px;width: 80px;text-align: center">EVENTOS</th>
                <th class="hidden-xs" style="padding: 10px;width: 80px;text-align: center">COBRANÇA</th>
                <th :style="{ width: isMobile ? '' : '300px' }" style=" text-align: center" v-if="edit">AÇÕES</th>
                </thead>
                <tbody>
                <tr v-for="u in telefones">
                    <td style="vertical-align: middle">{{u.numero}}</td>
                    <td style="vertical-align: middle">{{u.nome}}</td>
                    <td class="hidden-xs" style="vertical-align: middle">{{u.email}}</td>
                    <td class="hidden-xs" style="vertical-align: middle">{{u.parentesco}}</td>
                    <td class="hidden-xs" style="vertical-align: middle;text-align: center"><b>{{u.whatsapp ? "SIM" : "NÃO"}}</b></td>
                    <td class="hidden-xs" style="vertical-align: middle;text-align: center"><b>{{u.sms ? "SIM" : "NÃO"}}</b></td>
                    <td class="hidden-xs" style="vertical-align: middle;text-align: center"><b>{{u.eventos ? "SIM" : "NÃO"}}</b></td>
                    <td class="hidden-xs" style="vertical-align: middle;text-align: center"><b>{{u.cobranca ? "SIM" : "NÃO" }}</b></td>
                    <td v-if="edit" style="text-align:center;">
                        <button :class="{'btn-xs': ! isMobile, 'btn-sm': isMobile, }" @click="remove(u)"
                                class="btn btn-danger">
                            <li class="fa fa-trash-o"></li> EXCLUIR</button>
                        <button :class="{'btn-xs': ! isMobile, 'btn-sm': isMobile, }" @click="edicao(u)"
                                class="btn btn-info">
                            <li class="fa fa-edit"></li> EDITAR</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>
<script>
    import ComboTrueFalse from "../combos/ComboTrueFalse";
    import {isMobile} from "mobile-device-detect";
    import {Cliente} from '../../class';
    export default {
        name: 'TableTelefonesClientes',
        components: {ComboTrueFalse},
        props : {
            telefones: {
                "default": []
            },
            height: {
                type: String,
                default: 'calc(100vh - 400px);'
            },
            uuid: {
                default: null,
            },
            edit: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                isMobile: isMobile,
                id: null,
                contato: null,
                editar: false
            }
        },
        methods: {
            save () {
                if (! this.editar) {
                    this.telefones.push(this.contato);
                }
                this.cancelar();
            },
            remove (obj) {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente remover este contato?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode remover!'
                }).then(() => {
                    const index = this.telefones.indexOf(obj);
                    if (index > -1) {
                        this.telefones.splice(index, 1);
                    }
                });
            },
            saveTelefone () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente salvar estes telefones?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode salvar!'
                }).then(async () => {
                    await Cliente.saveTelefones(this.uuid, this.telefones);
                });
            },
            edicao (u) {
                if (! u.cod_pais ) {
                    u.cod_pais = "+55";
                }
                this.contato = u;
                this.editar = true;
            },
            novo () {
                this.contato = {
                    cod_pais: '+55',
                    whatsapp: false,
                    telegram_id: null,
                    parentesco: null,
                    eventos: false,
                    cobranca: false
                };

                this.editar = false;
            },
            cancelar () {
                this.contato = null;
                this.editar = false;
            }
        }
    }
</script>
